import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ArpioSharedModule } from '../shared/arpio-shared.module'
import { AuthRoutingModule } from './auth-routing.module'
import { AuthAcceptInviteComponent } from './components/auth-accept-invite/auth-accept-invite.component'
import { AuthFinishInviteComponent } from './components/auth-finish-invite/auth-finish-invite.component'
import { AuthShellComponent } from './components/auth-shell/auth-shell.component'
import { AuthVerifyEmail } from './components/auth-verify-email/auth-verify-email.component'
import { AuthComponent } from './components/auth/auth.component'
import { FinishResetPasswordComponent } from './components/finish-reset-password/finish-reset-password.component'
import { ResetPasswordComponent } from './components/reset-password/reset-password.component'

@NgModule({
  declarations: [
    AuthComponent,
    AuthShellComponent,
    ResetPasswordComponent,
    AuthAcceptInviteComponent,
    AuthFinishInviteComponent,
    AuthVerifyEmail,
    FinishResetPasswordComponent,
  ],
  imports: [CommonModule, ArpioSharedModule, AuthRoutingModule, FormsModule, ReactiveFormsModule],
})
export class AuthModule {}
